module.exports = __webpack_public_path__ + "static/img/touxiang.44571f7f.png";